import React, { Component } from "react";
import axios from "axios";
import { apiUrl, report } from "../../config/config";
import classnames from "classnames";
import $, { event } from "jquery";
import socketIOClient from "socket.io-client";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import LiveTag from "../../components/common/LiveTag";
import { livePatientsEnabled } from "../../config/config";
import AddModalComplete from "./AddModalComplete";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Select from "react-select";
import AddModalReport from "./AddModalReport";
import EcgStripsModal from "./EcgStripsModal";
import { format, parseISO } from "date-fns";
import "./patient-list.css";
import Countdown from "react-countdown";

import LinearProgress from "@material-ui/core/LinearProgress";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./worker.js";
import { duration } from "@material-ui/core";
import { Pointer, time } from "highcharts";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { ColumnSizing } from "@tanstack/react-table";
import url from "socket.io-client/lib/url";
import { Toaster, toast } from "react-hot-toast";

// Live progress socket disabled — re-enable once the backend at
// https://web.mybiocalculus.com:5000 has CORS configured for cross-origin
// credentialed requests. ProgressButton handles socket === null gracefully.
// const socket = socketIOClient("https://web.mybiocalculus.com:5000");
const socket = null;

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "10px",
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
};

// Priority as assigned to the patient (patient.priority is canonical; the
// legacy deviceInfo.priority is only a fallback for un-migrated rows).
// Same resolution as patient-list so both pages agree.
const getPatientPriority = (patient) => {
  if (!patient) return 4;
  const p = patient.priority;
  if (p !== undefined && p !== null && p !== "") {
    const n = Number(p);
    if (Number.isFinite(n) && n > 0) return n;
  }
  const dp = patient.deviceInfo && patient.deviceInfo.priority;
  if (dp !== undefined && dp !== null && dp !== "") {
    const n = Number(dp);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return 4;
};

// Queue rank: only an explicitly assigned priority (High=1, Moderate=2,
// Simple=3) moves a patient up. Normal (4) / unset = no priority.
const assignedPriorityRank = (patient) => {
  const p = getPatientPriority(patient);
  return p >= 1 && p <= 3 ? p : 99;
};

// Upload / confirm time as a comparable number, read as IST wall-clock
// digits so ConfirmupdatedDate ("...T..Z") and updatedDate ("YYYY-MM-DD
// HH:MM:SS") never skew against each other by a timezone offset.
const uploadTimeMs = (patient) => {
  const raw = (patient && (patient.ConfirmupdatedDate || patient.updatedDate)) || "";
  const m = String(raw).match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (!m) return Number.MAX_SAFE_INTEGER; // no upload yet → bottom
  return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
};

class VerificationCompletedList extends Component {
  constructor() {
    super();
       const menus = [
         { title: "Verifier Home", url: "/verifier-home" },
         { title: "Patient list", url: "/patient-list" },
         { title: "Labled Patients", url: "/labled-patients" },
         { title: "Verified", url: "/verification-completed" },
   
       ];
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
         menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
       }
   
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
       }
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, {
           title: "Supported Person",
           url: "/supported-persons",
         });

         }
          if (localStorage.getItem("AdminUser") === "8") {
           menus.splice(6, 0, {
             title: "Reset Password",
             url: "/ResetPassword",
           });
       }
    this.state = {
      menus,
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      patients: [],
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      macid: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
      errors: {},
      userid: "",
      smoking: "",
      diabetes: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      dob: null,
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      thyroid_function: "",
      cardiac_surgery: "",
      doctors: [],
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],
      doctor_id: "",
      doctor_name: "Choose",
      doctors: [],
      selectedDoctor: null,
      searchTerm: "",
      data: {},
      prog_data: 0,
      loading: false,
      socketNew: socket,
      patientDetails: null,
      ipop: "",
      priority: "",
      verifiertype: "",
      allverifiers: "",
      reportstatus: "",
      isModalReportOpen: false,
      generatereportuserid: "",
      treemenu: [],
      duration: "",
      customer_details: "",
      showButton: true,
      refreshKey: 0,
      filetype: "",
      sortedPatients: [],
      selectedVerifiersEfficency: [],
      hourstocompleted: "",
      gender: "",
      columns: [],
      rows: [],
      searchQuery: "",
      pacemaker: false,
      issueReport: "",
      Confirmation: "",
      blockReportOption: "",
      loadingEditModal: false, // Add loading state for edit modal
      // TAT notification tracking
      tatNotifications: new Set(), // Track which patients have been notified
      lastTatCheck: null, // Track last TAT check time
      isShowingNotification: false, // Track if a notification is currently being shown
      notificationQueue: [], // Queue for pending notifications
      supportPersons: [], // list from API
      supportPerson: "", // selected support person id
      supportLevel: "",
      supportedMatter: "",
      statusFilter: "All",
      stripsUserid: null, // patient _id whose uploaded ECG images the popup shows (null = closed)
      newComment: "",
    };
    this.intervalId = null;

    this.selectItem = this.selectItem.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.handleModalComplete = this.handleModalComplete.bind(this);

    this.submitComment = this.submitComment.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.getConfirmTime = this.getConfirmTime.bind(this);
    this.HandleVerifiedSpeed = this.HandleVerifiedSpeed.bind(this);
    this.getverifiedprogress = this.getverifiedprogress.bind(this);
    this.onGenderChange = this.onGenderChange.bind(this);
    this.filterRows = this.filterRows.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }
  componentDidMount() {
    // NOTE: this method is currently shadowed by a second componentDidMount
    // declared later in this class — only that one runs. Background-notification
    // popups have been removed from this page; see the live componentDidMount
    // further below for the active version.
    this.fetchData();

    // Set an interval to check the condition and fetch data
    this.intervalId = setInterval(() => {
      if (!this.state.isModalCompleteOpen) {
        this.fetchData();
      } else {
        console.log("Modal is open, skipping data refresh");
      }
    }, 30000); // 30 seconds
  }
  componentWillUnmount() {
    // Clear the interval when the component unmounts
    clearInterval(this.intervalId);
  }
  fetchData = () => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype });
    const worker = new Worker();

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;

    worker.postMessage({
      name: "alldoctors",
      url: apiUrl + "api/users/alldoctors",
    });

    worker.addEventListener("message", function (event) {
      newstat.setState({ doctors: event.data });
    });

    axios
      .all([
        axios.get(apiUrl + "api/users/getVerifierPatientsPercentageCompleted"),
        axios.get(apiUrl + "api/users/allverifiers"),
      ])
      .then(
        axios.spread((patientsRes, verifiersRes) => {
          const filteredPatients = patientsRes.data.sortedPatients.filter(
            (patient) =>
              // Live patients finish the normal flow too (shown with a LIVE tag)
              patient.Confirmation === "Yes" || patient.Confirmation === "No" ||
              patient.Confirmation === "Live"
          );

          this.setState(
            {
              patients: filteredPatients,
              allverifiers: verifiersRes.data,
            },
            () => {
              // Ordering (upload-time queue):
              //   1. patients given a priority through the edit/priority
              //      option (High=1 → Moderate=2 → Simple=3). Normal/unset
              //      has no effect.
              //   2. upload time, oldest first (ConfirmupdatedDate, else
              //      the device's updatedDate).
              // The Prioritize Yes/No flag and priority-band grouping no
              // longer influence the order.
              const sortedPatients = this.state.patients.slice().sort((a, b) => {
                const aPr = assignedPriorityRank(a);
                const bPr = assignedPriorityRank(b);
                if (aPr !== bPr) return aPr - bPr;
                return uploadTimeMs(a) - uploadTimeMs(b);
              });

              // console.log('percentage',patientsWithPercentages);  // Log the updated patients array with percentage

              const data = {
                columns: [
                  { label: "SL NO", field: "slno", sort: "asc", width: 0.5 },
                  {
                    label: "PATIENT ID",
                    field: "patientId",
                    sort: "asc",
                    width: 5,
                  },
                  {
                    label: "ADDED DATE",
                    field: "added_date",
                    sort: "asc",
                    width: 5,
                  },
                  { label: "NAME", field: "name", sort: "asc", width: 5 },
                  {
                    label: "CUSTOMER NAME",
                    field: "distributor",
                    sort: "disabled",
                    width: 5,
                  }, // Existing column
                  {
                    label: "DOCTOR NAME",
                    field: "doctor_name",
                    sort: "asc",
                    width: 5,
                  },
                  {
                    label: "Priority",
                    field: "priority",
                    sort: "disabled",
                    width: 5,
                  }, // Existing column

                  {
                    label: "ACTION",
                    field: "action",
                    sort: "disabled",
                    width: 5,
                  },
                  {
                    label: "MONITORING",
                    field: "monitoring_duration",
                    sort: "disabled",
                    width: 1,
                  },
                ],
                rows: [],
              };

              sortedPatients.forEach((patient, i) => {
                const Priority =
                  (patient.deviceInfo && patient.deviceInfo.Priority) || 4; // Set Priority value

                // Variable to store the final time value
                let finalTime;

                // Ensure the date fields are not undefined or null before splitting
                if (patient.ConfirmupdatedDate) {
                  // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
                  let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

                  // Get the date part before 'T'
                  let confirmDate = confirmButtonTime[0]; // '2024-11-29'

                  // Get the time part after 'T'
                  let confirmTime = confirmButtonTime[1]
                    ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
                    : ""; // If no time part, default to an empty string

                  // Handle removing milliseconds (if any) from confirmTime
                  if (confirmTime) {
                    let time = confirmTime.split(".")[0]; // Get time without milliseconds
                    const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
                    // console.log("Confirm button time:", confirmbtnTime);

                    // Assign confirmbtnTime to finalTime if available
                    finalTime = confirmbtnTime;
                  } else {
                    // console.log("Confirm Time is empty or invalid");
                  }
                } else {
                  // console.log("ConfirmupdatedDate is undefined or null");
                }

                // Check and split the 'updatedDate' if it's available
                if (patient.updatedDate) {
                  // Split the 'updatedDate' by space to separate date and time
                  let updatedDateTime = patient.updatedDate.split(" ");

                  // Get the date part before the space
                  let updatedDate = updatedDateTime[0]; // '2024-11-29'

                  // Get the time part after the space
                  let updatedTime = updatedDateTime[1]; // '10:28:34'

                  // console.log("Updated Date:", updatedDate, updatedTime);

                  // Combine updatedDate and updatedTime with a space between them
                  const uploadedTime = updatedDate + " " + updatedTime;

                  // Assign uploadedTime to finalTime if confirmbtnTime was not set
                  if (!finalTime) {
                    finalTime = uploadedTime;
                  }
                } else {
                  // console.log("UpdatedDate is undefined or null");
                }

                // Log the final time
                // console.log("Final Time:", finalTime);

                // Get the current time
                const now = new Date();

                // Convert finalTime to Date object
                const finalDate = new Date(finalTime);
                const finalDateMs = finalDate.getTime();
                const isFinalDateValid = Number.isFinite(finalDateMs);

                // Calculate the time difference in milliseconds
                const timeDifference = isFinalDateValid ? now - finalDate : 0; // in milliseconds

                // Convert time difference to hours
                const hoursDifference = timeDifference / (1000 * 60 * 60); // milliseconds to hours

                // Set the time limit based on priority
                let timeLimit;
                switch (Priority) {
                  case 1:
                    timeLimit = 1; // 1 hours
                    break;
                  case 2:
                    timeLimit = 2; // 3 hours
                    break;
                  case 3:
                    timeLimit = 3;
                  case 4:
                    timeLimit = 4; // 4 hours
                    break;
                  case 5:
                    timeLimit = 5; // 8 hours
                    break;
                  default:
                    timeLimit = 4; // 10 hours (for priority 5, as an example)
                }

                // Calculate the percentage of time used

                let exp_device =
                  patient.exp_device_use_days === 24
                    ? 1
                    : patient.exp_device_use_days === 48
                    ? 2
                    : patient.exp_device_use_days === 72
                    ? 3
                    : patient.exp_device_use_days;

                const totalAllowedMs = timeLimit * (exp_device || 1) * 60 * 60 * 1000;
                const countdownEndTime = isFinalDateValid ? finalDateMs + totalAllowedMs : null;

                let timePercentage =
                  (hoursDifference / (timeLimit * (exp_device || 1))) * 100;
                if (!Number.isFinite(timePercentage) || timePercentage < 0) timePercentage = 0;
                if (timePercentage > 100) {
                  timePercentage = 100;
                }
                // Calculate the completion rate (percentage per hour)
                // Calculate the completion rate (percentage per hour)
                const completionRate = timePercentage / hoursDifference; // percentage per hour

                // Predict the total time to complete 100% (in hours)
                const totalCompletionTime = 100 / completionRate; // in hours

                // Calculate the remaining time to complete (in hours)
                const remainingTimeInHours =
                  totalCompletionTime - hoursDifference;

                // Convert the remaining time to minutes
                const remainingTimeInMinutes = remainingTimeInHours * 60;

                // Convert minutes into hours and minutes
                const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
                const minutes = Math.round(remainingTimeInMinutes % 60); // Get the remaining minutes

                // Log the predicted remaining time
                // console.log(
                //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
                // );

                // console.log("name", patient.name);
                // console.log("percetage", timePercentage);
                // console.log("timediff", timeDifference);
                // console.log("time limit", timeLimit);

                // Log the result
                // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
                // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
                // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
                const percentage = timePercentage.toFixed(2);
                const devicemac =
                  patient && patient.deviceInfo && patient.deviceInfo.mac_id;
                // console.log("patient", devicemac);
                // Same resolution as patient-list: the patient's own
                // customerName is canonical; the device record's
                // customer_details is only a fallback for old patients that
                // predate the customerName field. Reading the device alone
                // left the column blank whenever the device row was missing
                // or had no customer_details.
                const Distributor_name =
                  (patient && patient.customerName) ||
                  (patient &&
                    patient.deviceInfo &&
                    patient.deviceInfo.customer_details) ||
                  "";
                // Patient-assigned priority (same resolution used for the
                // queue order above), so tag and position always agree.
                const devicepriority = getPatientPriority(patient);

                const totalEcgValues = patient.ecgValues.length;
                const verifiedEcgValues = patient.ecgValues.filter(
                  (ecgValue) => ecgValue.verifyStatus === 1
                );
                const verifiedPercentage = `${verifiedEcgValues.length} /${totalEcgValues} `;

                const createdData = patient.created_at.split("T");

                let url = " ";
                let anl_btn_txt = "teststart";
                let anl_btn_class = "btn-danger";
                let gen_btn_txt = "Not Generated";
                let gen_btn_class = "btn-danger";
                let report_link = report+"?userid="+patient._id;
                let report_link_target = "_blank";

                if (patient.LastDatasetId !== undefined) {
                  url =
                    patient.backup_status === 0 ||
                    patient.backup_status === undefined
                      ? `/verifier-unanalysed/${patient._id}/${patient.LastDatasetId}`
                      : " ";
                }

                if (patient.report_status >= 1) {
                  anl_btn_txt = "Analyzing...";
                  anl_btn_class = "btn-success";
                }

                if (patient.report_status >= 2) {
                  anl_btn_txt = "test";
                  anl_btn_class = "btn-success";
                  url =
                    patient.backup_status === 0 ||
                    patient.backup_status === undefined
                      ? `/verifier-chart/${patient._id}/${patient.LastDatasetId}`
                      : " ";
                }

                if (patient.report_status >= 4) {
                  gen_btn_txt = "In Preparation";
                  gen_btn_class = "btn-yellow";
                }
                if (patient.report_status >= 5) {
                  gen_btn_txt = "View Report";
                  gen_btn_class = "btn-success";
                  report_link_target = "_blank";
                  report_link = "";
                }

                anl_btn_txt =
                  patient.backup_status === 0 ||
                  patient.backup_status === undefined
                    ? "TEST3"
                    : patient.backup_status === 1
                    ? "Retrieve"
                    : "Retrieving";

                const updateddate = patient.ConfirmupdatedDate
                  ? patient.ConfirmupdatedDate.replace("T", " ").split(
                      ".000Z"
                    )[0]
                  : patient.updatedDate;

                data.rows.push({
                  slno: i + 1,
                  _id: patient._id,
                  report_status: patient.report_status,
                  reportGenerated: !!patient.ReportGeneration,
                  // Upload time as a number, for oldest-first ordering
                  // inside each priority band.
                  uploadMs: uploadTimeMs(patient),
                  // Only an explicitly assigned High/Moderate/Simple counts;
                  // everything else is "unprioritised" (bucket 4).
                  priorityNum: assignedPriorityRank(patient) <= 3 ? assignedPriorityRank(patient) : 4,
                  patientId: patient.device_id,
                  added_date: createdData[0],
                  confirmation: patient.Confirmation,
                  name: capitalizeFirstLetter(patient.name),
                  distributor: Distributor_name,
                  doctor_name: patient.doctorName,
                  priority: (() => {
                    const rank = assignedPriorityRank(patient); // 1/2/3 or 99
                    const tagMap = {
                      1: { label: "High",     cls: "priority-tag-high"     },
                      2: { label: "Moderate", cls: "priority-tag-moderate" },
                      3: { label: "Simple",   cls: "priority-tag-simple"   },
                    };
                    const tag = tagMap[rank]; // undefined → not prioritised
                    return tag
                      ? <span className={`priority-tag ${tag.cls}`}>{tag.label}</span>
                      : <span style={{ color: "#5b7688", fontSize: "11px", opacity: 0.7 }}>—</span>;
                  })(),
                  comments: patient.comments || "",

                  monitoring_duration: (() => {
                    const d = Number(patient.exp_device_use_days);
                    const days = d >= 24 ? Math.round(d / 24) : d;
                    const dateStr = updateddate || "—";
                    let confirmDate = "", confirmTime = "";
                    if (patient.ConfirmupdatedDate) {
                      const p = patient.ConfirmupdatedDate.split("T");
                      confirmDate = p[0] || "";
                      confirmTime = p[1] ? p[1].split(".")[0].replace("Z", "") : "";
                    }
                    const tatSection = countdownEndTime ? (
                      <Countdown date={countdownEndTime} renderer={({ hours, minutes, completed }) => {
                        const reportDone = !!patient.ReportGeneration;
                        const isAlarm = (completed || timePercentage >= 80) && !reportDone;
                        const c = isAlarm ? "#ff3b30" : timePercentage >= 50 && !reportDone ? "#ff9f0a" : "#30d158";
                        const bg = isAlarm ? "#3a0a08" : timePercentage >= 50 && !reportDone ? "#3a2208" : "#0a2a14";
                        return (
                          <span style={{ display: "inline-flex", alignItems: "center", gap: "3px", background: bg, border: `1px solid ${c}`, borderRadius: "20px", padding: "1px 8px" }}>
                            <span style={{ fontSize: "10px", color: c }}>{reportDone && completed ? "✅" : "⏱"}</span>
                            <span style={{ fontSize: "11px", fontWeight: 700, color: c, fontVariantNumeric: "tabular-nums" }}>
                              {completed ? (reportDone ? "Delivered" : "TIME OVER") : `${String(hours).padStart(2,"0")}h ${String(minutes).padStart(2,"0")}m`}
                            </span>
                          </span>
                        );
                      }} />
                    ) : (
                      <span style={{ fontSize: "10px", color: "#555", background: "rgba(255,255,255,0.06)", borderRadius: "12px", padding: "1px 8px", border: "1px solid #333" }}>No TAT</span>
                    );
                    return (
                      <div style={{ display: "flex", gap: "10px", fontSize: "12px", lineHeight: 1.6, alignItems: "flex-start" }}>
                        <input type="hidden" className="patientLink" value={url} />

                        {/* Section 1 — Left: actions top, TAT bottom */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
                            {this.state.verifiertype === "8" && (
                              <button type="button" id={patient._id} dataid2={devicemac} dataid3={devicepriority}
                                title="Edit Patient" onClick={this.getInfo} data-toggle="modal" data-target="#editInfoModal"
                                style={{ background: "none", border: "none", padding: "2px 4px", cursor: "pointer", color: "#f0a500", fontSize: "15px", lineHeight: 1 }}>✏️</button>
                            )}
                            <button type="button" id={patient._id}
                              style={{ padding: "2px 7px", fontSize: "11px", height: "24px", lineHeight: 1, background: "#2c5f8a", border: "1px solid #3a82c4", color: "#fff", borderRadius: "4px", display: "inline-flex", alignItems: "center", gap: 3 }}
                              onClick={this.getInfo} data-toggle="modal" data-target="#commentinfomodal" title="Comments">
                              💬
                              {(() => {
                                const cnt = patient.comments ? patient.comments.split("\n").filter(l => l.trim()).length : 0;
                                return <span style={{ fontSize: "10px", background: cnt > 0 ? "#e8f4fd" : "rgba(255,255,255,0.15)", color: cnt > 0 ? "#1a6fa3" : "#aad4f5", borderRadius: 8, padding: "0 5px", fontWeight: 700, minWidth: 14, textAlign: "center" }}>{cnt}</span>;
                              })()}
                            </button>
                            {this.state.verifiertype === "8" && !patient.ConfirmupdatedDate && (
                              <button type="button" id={patient._id}
                                style={{ padding: "1px 6px", fontSize: "13px", lineHeight: 1, background: "none", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "4px", cursor: "pointer" }}
                                onClick={this.getConfirmTime} title="Confirm">✅</button>
                            )}
                            <span id={patient._id} onClick={this.getverifiedprogress}
                              data-toggle="modal" data-target="#progressinfomodal"
                              style={{ cursor: "pointer", fontSize: "11px", color: "#5ac8fa", background: "rgba(90,200,250,0.12)", border: "1px solid rgba(90,200,250,0.3)", borderRadius: "8px", padding: "1px 7px" }}>
                              📁 {verifiedPercentage}
                            </span>
                          </div>
                          {/* Images (icon only) + remaining time on one line,
                              under the dataset count. */}
                          <div style={{ display: "flex", alignItems: "center", gap: "5px", flexWrap: "wrap" }}>
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); this.setState({ stripsUserid: patient.device_id }); }}
                              title="View uploaded ECG images"
                              style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "13px", color: "#5ac8fa", background: "transparent", border: "1px solid rgba(90,200,250,0.4)", borderRadius: "6px", padding: "1px 7px", cursor: "pointer" }}
                            >
                              🖼
                            </button>
                            <div>{tatSection}</div>
                          </div>
                        </div>

                        {/* Section 2 — Middle: duration top, uploaded + confirm bottom */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0, alignItems: "center", textAlign: "center" }}>
                          <span style={{ background: "rgba(90,200,250,0.15)", color: "#5ac8fa", border: "1px solid rgba(90,200,250,0.3)", borderRadius: "10px", padding: "1px 8px", fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
                            {days} Day{days !== 1 ? "s" : ""}
                          </span>
                          <span style={{ fontSize: "11px", opacity: 0.65, whiteSpace: "nowrap" }}>{dateStr}</span>
                          {confirmDate && (
                            <span style={{ fontSize: "11px", color: "#30d158", whiteSpace: "nowrap" }}>
                              ✔ {confirmDate}{confirmTime ? ` ${confirmTime}` : ""}
                            </span>
                          )}
                        </div>

                        {/* Section 3 — Right: report status */}
                        <div style={{ display: "flex", alignItems: "flex-start", marginLeft: "auto" }}>
                          <a href={report_link} target={report_link_target} id={patient._id}
                            onClick={() => this.generateReport(patient.report_status, patient._id)}>
                            <button type="button" className={`btn btn-sm ${gen_btn_class}`}
                              style={{ padding: "1px 8px", fontSize: "11px", whiteSpace: "nowrap", ...(gen_btn_class === "btn-yellow" ? { backgroundColor: "#2ecd99" } : {}) }}>
                              {gen_btn_txt}
                            </button>
                          </a>
                        </div>
                      </div>
                    );
                  })(),

                  TimePercentage: (
                    <div style={{ color: "transparent", display: "flex", position: "absolute" }}>
                      {timePercentage.toFixed(2)}
                    </div>
                  ),

                  // legacy action kept for compat (hidden in new layout)
                  action: (
                    <React.Fragment>
                      <div style={{ display: "none" }}>
                        <ProgressBtn
                          id={patient._id}
                          bc_stat={patient.backup_status}
                          onSelectModalComplete={this.handleModalComplete}
                          r_stat={patient.report_status}
                          // socket={this.state.socketNew}
                          isPatientListPage={true}
                        />
                        {this.state.verifiertype === "8" && (
                          <button
                            type="button"
                            id={patient._id}
                            dataid2={devicemac}
                            dataid3={devicepriority}
                            style={{
                              float: "left",
                              marginRight: "10px",
                              width: "67px",
                            }}
                            onClick={this.getInfo}
                            className="btn btn-warning"
                            data-toggle="modal"
                            data-target="#editInfoModal"
                          >
                            Edit
                          </button>
                        )}
                        <button
                          key={patient.id}
                          id={patient._id}
                          hourcomplete={`${hours} hours and ${minutes} minutes`}
                          type="button"
                          style={{
                            float: "left",
                            marginRight: "10px",
                            width: "90px",
                          }}
                          className="btn btn-primary"
                          data-toggle="modal"
                          onClick={this.getverifiedprogress}
                          data-target="#progressinfomodal"
                        >
                          {verifiedPercentage}
                        </button>
                        {this.state.verifiertype === "8" && (
                          <select
                            style={{
                              color: "black",
                              width: "110px",
                              height: "36px",
                              float: "left",
                              backgroundColor: "gray",
                              border: "none",
                            }}
                          >
                            {this.state.allverifiers.filter((verifier) =>
                              verifier.patients.includes(patient._id)
                            ).length === 0 && (
                              <option
                                style={{ color: "gray" }}
                                disabled
                                selected
                              >
                                Not Assigned
                              </option>
                            )}
                            {this.state.allverifiers
                              .filter((verifier) =>
                                verifier.patients.includes(patient._id)
                              )
                              .map((verifier) => (
                                <option
                                  style={{ color: "black" }}
                                  key={verifier._id}
                                  value={verifier._id}
                                >
                                  {verifier.name}
                                </option>
                              ))}
                          </select>
                        )}

                        <button
                          type="button"
                          id={patient._id}
                          style={{
                            float: "left",
                            marginLeft: "10px",
                            width: "130px",
                            marginRight: "10px",
                          }}
                          onClick={this.getInfo}
                          className="btn btn-warning"
                          data-toggle="modal"
                          data-target="#commentinfomodal"
                        >
                          comments
                        </button>

                        {this.state.verifiertype === "8" &&
                        !patient.ConfirmupdatedDate ? (
                          <button
                            type="button"
                            id={patient._id}
                            style={{
                              float: "left",
                              marginLeft: "0px",
                              width: "80px",
                              marginRight: "10px",
                              backgroundColor: "transparent",
                              border: "none",
                              fontSize: "30px",
                              padding: "10px 20px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={this.getConfirmTime}
                            className="btn"
                          >
                            ✅
                          </button>
                        ) : null}
                      </div>
                    </React.Fragment>
                  ),

                });
              });

              this.setState({ data: data });
              this.setState({ columns: data.columns });
              this.setState(
                {
                  // Keep the queue order computed above (assigned priority,
                  // then oldest upload first) — no re-sort by priority band.
                  rows: data.rows,
                },
                () => {
                  this.applyRowStyles(); // Apply styles to rows

                  // Bind click events for table rows after setting state
                  const table = document.getElementById("table");
                  if (table) {
                    table.addEventListener("click", this.handleRowClick);
                  }

                  // TAT notification check removed — background notification
                  // popups are no longer surfaced on this page.
                }
              );

              // this.setState({ data }, () => {
              //   this.applyRowStyles();

              //   // Bind click events for table rows
              //   const table = document.getElementById("table");
              //   table.addEventListener("click", (event) => {
              //     const target = event.target;
              //     if (
              //       target.closest(
              //         "td:nth-child(2), td:nth-child(3), td:nth-child(4)"
              //       )
              //     ) {
              //       const url = target
              //         .closest("tr")
              //         .querySelector(".patientLink").value;
              //       if (url !== " ") {
              //         window.location.href = url;
              //         // console.log("url:", url);
              //       }
              //     }
              //   });
              // });
            }
          );
        })
      )
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };
  componentDidMount() {
    // Fetch data initially
    this.fetchData();

    // Background notifications removed by request:
    //   * `fetchNotifications()` polled every 2s and surfaced server messages
    //     as toast popups on this page — disabled.
    //   * TAT notification checks (toast.error / toast() for delayed patients)
    //     and their reset interval — disabled.
    // Action-feedback toasts (e.g. "Confirmation Updated to: …",
    // "Patient Report Blocked") are unaffected.

    // Set an interval to check the condition and fetch data
    this.intervalId = setInterval(() => {
      if (!this.state.isModalCompleteOpen) {
        this.fetchData();
      } else {
        console.log("Modal is open, skipping data refresh");
      }
    }, 30000); // 30 seconds

    // Check if we need to reset notifications (daily reset)
    const now = new Date();
    const lastReset = localStorage.getItem("lastTatNotificationReset");
    const today = now.toDateString();

    if (lastReset !== today) {
      this.resetTatNotifications();
      localStorage.setItem("lastTatNotificationReset", today);
    }
  }

  componentWillUnmount() {
    // Clear the data-refresh interval when the component unmounts
    clearInterval(this.intervalId);
  }
  handleRowClick(event) {
    const target = event.target;

    // Check if the click happened on the specific columns (2, 3, or 4)
    if (target.closest("td:nth-child(2), td:nth-child(3), td:nth-child(4)")) {
      const row = target.closest("tr");
      const urlElement = row.querySelector(".patientLink");
      const url = urlElement ? urlElement.value : ""; // Avoid optional chaining

      // Check if a URL exists and navigate to it
      if (url && url.trim() !== "") {
        window.location.href = url;
      }
    }
  }

  applyRowStyles() {
    const { rows } = this.state;

    if (rows) {
      // Directly modify styles in JSX instead of using jQuery
      const updatedRows = rows.map((row) => {
        const percentage = 0; // row styles now handled by priority grouping

        let backgroundColor = "#8f8b8b"; // Default color
        if (percentage >= 50 && percentage <= 70) {
          backgroundColor = "#008080"; // Light green for percentage 50-60
        } else if (percentage >= 71 && percentage <= 90) {
          backgroundColor = "#2ecd99"; // Light yellow for percentage 71-90
        } else if (percentage >= 91 && percentage <= 100) {
          backgroundColor = "#e0544a"; // Dark yellow for percentage 91-100
        }

        // Return the updated row with a background color
        return { ...row, backgroundColor };
      });

      // Update state with the new rows including the background color
      this.setState({ rows: updatedRows });
    }
  }

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return;
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;
    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      $(".closePopup").click();
      this.setState({ newComment: "", comments: "" });
      this.fetchData();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };
  filterRows = () => {
    const { rows, searchQuery, statusFilter } = this.state;

    let filtered = rows;

    if (statusFilter && statusFilter !== "All") {
      filtered = filtered.filter((row) => {
        const rs = row.report_status;
        if (statusFilter === "Not Started") return rs === 0;
        if (statusFilter === "Analyze Started") return rs >= 1 && rs < 2;
        if (statusFilter === "Analyze Completed") return rs >= 2;
        return true;
      });
    }

    if (searchQuery) {
      filtered = filtered.filter((row) =>
        [row.patientId, row.name, row.added_date, row.distributor, row.doctor_name]
          .some((v) => v && String(v).toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }

    return filtered;
  };

  // Method to apply styles to rows based on priority

  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };

  async generateReport(reportstatus, userid) {
    //  const userid=e.currentTarget.id

    // console.log("generate event id:", userid);
    this.setState({ generatereportuserid: userid });
    if (reportstatus == "2") {
      const res = await axios.get(
        apiUrl + "api/common/patinentmenutreeNew?userid=" + userid
      );

      this.setState({ treemenu: res.data });

      this.setState({ isModalReportOpen: true });
    }
    if (reportstatus == "3") {
      const res = await axios.get(
        apiUrl + "api/common/patinentmenutreeNew?userid=" + userid
      );

      this.setState({ treemenu: res.data });
      this.setState({ isModalReportOpen: true });
    } else {
      this.setState({ isModalReportOpen: false });
    }
  }

  handleVerifierChange = (selectedOptions) => {
    this.setState({
      selectedVerifiers: selectedOptions || [], // Update selected verifiers or set empty array if none
    });
    // console.log("selected options", selectedOptions);
    // console.log(
    //   "selected verifier state",
    //   this.state.selectedVerifiers,
    //   this.state.selectedVerifierIds
    // );
  };

  handleModalComplete(id) {
    // console.log("id:", id);
    this.state.userid = id;
    this.setState({ isModalCompleteOpen: true });
  }

  onSubmit = (e) => {
    e.preventDefault();

    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
        // console.log("onclick");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
    };
    // console.log("info:", info);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    // console.log("onChange");
    // console.log(e.target.name);
    // console.log(e.target.value);
    // console.log(e.target)
    // this.setState({reportstatus:e.target.value})
    // console.log(e.target.value)

    this.setState({ [e.target.name]: e.target.value });
  };
  handleTypeChange = (e) => {
    // console.log("e.target.value", e.target.value);
    this.setState({ filetype: e.target.value });
  };
  handleDateChange = (inputDate) => {
    // Check if the input date is a valid ISO string
    if (moment(inputDate, moment.ISO_8601, true).isValid()) {
      // Convert the input string into a Date object
      const date = new Date(inputDate);

      // Format the date as desired (ISO format with time zone offset)
      const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");

      // console.log("Formatted Date:", formattedDate);
      // Outputs: 2024-11-06T00:00:00.000+05:30
      this.setState({ dob: formattedDate });
    } else {
      console.error("Invalid date format:", inputDate);
    }
  };
  onIpOpChange = (e) => {
    console.log("ipop", e.target.value);
    this.setState({ ipop: e.target.value });
  };
  onDurationChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ duration: e.target.value });
    console.log(this.state.duration);
  };
  onPriorityChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];

    // console.log(e.target.value)
    this.setState({ priority: e.target.value });
  };
  onReportStatuschange = (e) => {
    // console.log("report stats change",e.target.value)
    this.setState({ reportstatus: e.target.value });
  };
  onGenderChange = (e) => {
    this.setState({ gender: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }
  HandleVerifiedSpeed(e) {
    console.log(e.target.value);
  }

  getInfo(e) {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    this.setState({ isModalCompleteOpen: false });
    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        if (Array.isArray(data.customer_details)) {
          data.customer_details.forEach((customer) => {
            if (customer.customer_details) {
              // console.log('Nested Customer Details:', customer);
              this.setState({ customer_details: customer.customer_details });
            }
          });
        }
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "", // <-- Add this line
        });
        // console.log("clinical condition:", data.clinicalCondition);
        // Handle DOB formatting
        let formattedDob = data.dob;
        if (formattedDob) {
          // Convert ISO string or YYYY-MM-DD to MM/DD/YYYY for display
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            formattedDob = `${mm}/${dd}/${yyyy}`;
          }
        }
        this.setState({ dob: formattedDob });
        // console.log("Formatted DOB:", this.state.dob);

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }
  getverifiedprogress(e) {
    this.setState({ isModalCompleteOpen: false });
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      hourstocompleted: "",
      selectedVerifiersEfficency: [],
      loadingVerifierProgress: true,
    });

    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    const hourstocompleted = e.target.getAttribute("hourcomplete");
    this.setState({ hourstocompleted: hourstocompleted });

    // console.log("current target", hourstocompleted);
    this.setState({ userid: userid });

    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        if (Array.isArray(data.customer_details)) {
          data.customer_details.forEach((customer) => {
            if (customer.customer_details) {
              // console.log('Nested Customer Details:', customer);
              this.setState({ customer_details: customer.customer_details });
            }
          });
        }
        // console.log(this.state.patients);

        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
        });

        // Handle DOB formatting
        const dob = new Date(Date.parse(data.dob));
        const formattedDob = `${
          dob.getMonth() + 1
        }/${dob.getDate()}/${dob.getFullYear()}`;
        this.setState({ dob: formattedDob });

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers_new`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        // selectedVerifiers used to be filtered here by verifier.patients
        // (the live assignment array) — that hides real past verification
        // activity for any verifier no longer carrying this patient in
        // their `patients` array (assignment cleaned up, or made via
        // verifier_blocks without ever touching `patients`). The actual
        // "who verified this patient" filter now happens once ecgValues
        // (the real activity record) comes back below — same fix already
        // applied in patient-list.js's copy of this same modal.
        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        // Build selectedVerifiers from WHO ACTUALLY VERIFIED this patient
        // (ecgValues.verifierId) and resolve a display name from
        // allverifiers_new — an ID that can't be resolved (deleted/merged
        // account) still shows up, labeled, instead of silently vanishing.
        const activeVerifierIds = Array.from(
          new Set((ecgValues || []).map((ecg) => ecg.verifierId).filter(Boolean))
        );
        const allVerifiers = this.state.verifiers || [];
        const verifierById = {};
        allVerifiers.forEach((v) => { verifierById[v.value] = v; });
        const selectedVerifiers = activeVerifierIds.map(
          (id) => verifierById[id] || { value: id, label: `Unknown verifier (${id})`, patients: [] }
        );
        this.setState({ selectedVerifiers: selectedVerifiers });
        const fileType = this.state.filetype || "easy"; // 'easy', 'medium', 'hard'

        const allowedTimePerECGInMinutes =
          fileType === "easy" ? 4 : fileType === "medium" ? 6 : 9;

        const verifierEfficiencyResults = [];

        if (selectedVerifiers && selectedVerifiers.length > 0) {
          // Track outstanding per-verifier POSTs so the loading spinner
          // only clears once every verifier has finished computing —
          // otherwise the modal shows "No verification activity yet"
          // briefly before the real results arrive.
          let pendingVerifierFetches = 0;
          const markFetchDone = () => {
            pendingVerifierFetches--;
            if (pendingVerifierFetches <= 0) {
              this.setState({ loadingVerifierProgress: false });
            }
          };
          selectedVerifiers.forEach((verifier) => {
            const hasFiles = ecgValues.some(
              (ecg) => ecg.verifierId === verifier.value
            );
            if (hasFiles) pendingVerifierFetches++;
          });
          if (pendingVerifierFetches === 0) {
            this.setState({ loadingVerifierProgress: false });
          }

          selectedVerifiers.forEach((verifier) => {
            const filteredECGValues = ecgValues
              .filter((ecg) => ecg.verifierId === verifier.value)
              .sort((a, b) => new Date(a.verifyTime) - new Date(b.verifyTime));

            if (filteredECGValues.length > 0) {
              // Here you can extract any data you need from `filteredECGValues` and pass it as a parameter
              // Assuming we are passing the `filteredECGValues` directly or extracting an ID or relevant data for `databaseid`
              const databaseId = filteredECGValues
                .map((ecg) => ecg.ecgvalue_id)
                .join(","); // Assuming `id` is the relevant field

              axios
                .post(
                  `${apiUrl}api/common/getTotalStripCount?userid=${userid}&databaseid=${databaseId}`
                )
                .then((apiResponse) => {
                  const apiData = apiResponse.data;

                  const totalMinutes = apiData; // Example input

                  const hours = Math.floor(totalMinutes / 60); // Get the number of hours
                  const minutes = totalMinutes % 60; // Get the remaining minutes

                  const formattedTime = `${hours}Hrs:${minutes
                    .toString()
                    .padStart(2, "0")}Mins`; // Format as hrs:mins
                  console.log("Formatted time (hours:min):", formattedTime);

                  const startTime = new Date(filteredECGValues[0].verifyTime);
                  const endTime = new Date(
                    filteredECGValues[filteredECGValues.length - 1].verifyTime
                  );

                  let totalEfficientCount = 0;
                  let totalComparisons = 0;
                  let totalTimeSpentInMinutes = 0;

                  filteredECGValues.forEach((ecg, index) => {
                    if (index > 0) {
                      const prevVerifyTime = new Date(
                        filteredECGValues[index - 1].verifyTime
                      );
                      const currentVerifyTime = new Date(ecg.verifyTime);
                      const timeDifferenceInMinutes =
                        (currentVerifyTime - prevVerifyTime) / (1000 * 60);

                      totalTimeSpentInMinutes += timeDifferenceInMinutes;

                      if (
                        timeDifferenceInMinutes <= allowedTimePerECGInMinutes
                      ) {
                        totalEfficientCount++;
                      }

                      totalComparisons++;
                    }
                  });

                  const efficiency =
                    totalComparisons > 0
                      ? (totalEfficientCount / totalComparisons) * 100
                      : 0;
                  const averageTimePerECG =
                    totalComparisons > 0
                      ? totalTimeSpentInMinutes / totalComparisons
                      : 0;
                  const remainingECGCount =
                    ecgValues.length - filteredECGValues.length;
                  const estimatedRemainingTime =
                    averageTimePerECG * remainingECGCount;

                  verifierEfficiencyResults.push({
                    label: verifier.value,
                    value: efficiency.toFixed(2),
                    averageTimePerECG: averageTimePerECG.toFixed(2),
                    estimatedRemainingTime: estimatedRemainingTime.toFixed(2),
                    startTime: startTime.toISOString(),
                    endTime: endTime.toISOString(),
                    totalTimeSpentInMinutes: totalTimeSpentInMinutes || "N/A",
                    totalSpendHours: formattedTime || "N/A",
                    totalEfficientCount: totalEfficientCount || "N/A",
                  });

                  this.setState({
                    selectedVerifiersEfficency: verifierEfficiencyResults,
                  });
                  markFetchDone();
                })
                .catch((err) => {
                  console.error("Error fetching data from API", err);
                  markFetchDone();
                });
            } else {
              console.log(
                `No ECG values found for Verifier ID: ${verifier.value}`
              );
            }
          });
        } else {
          console.log("No selected verifiers found.");
        }

        const totalLength = ecgValues.length;
        let verifyCount = 0;

        ecgValues.forEach((value) => {
          if (value.verifyStatus === 1) {
            verifyCount++;
          }
        });

        if (totalLength > 0) {
          const percentageVerified = (verifyCount / totalLength) * 100;
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
        }
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
      });
  }
  getConfirmTime(e) {
    console.log(e.currentTarget.id);
    const userid = e.currentTarget.id;
    const now = new Date();
    const updatedDate = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    // console.log("Clicked date and time:", updatedDate);

    // Make the API call
    axios
      .post(`${apiUrl}api/patients/updateUpdateDate`, {
        userid,
        updatedDate,
      })
      .then((response) => {
        // console.log(response);

        // Set showButton to false to hide the button after successful update
        this.setState({ showButton: false }, () => {
          // console.log("Button hidden:", this.state.showButton); // Ensure the state is updated
        });
        this.setState((prevState) => ({
          refreshKey: prevState.refreshKey + 1,
        }));
        this.fetchData();
      })
      .catch((error) => {
        // console.error("Error updating date:", error);
      });
  }

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  resetModalReport() {
    // console.log("resetmodal clicked!!!");
    this.setState({ isModalReportOpen: false });
    this.fetchData();
  }
  resetInfoModal() {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      customer_details: "", // Reset customer details too
      reportstatus: "",
      dob: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      doctor_name: "",
      doctor_id: "",
      duration: "",
      selectedVerifiers: [],
      verifiers: [],
      comments: "",
      priority: "",
      ipop: "",
      percentageVerified: "",
      macid: "",
      filetype: "",
      hourstocompleted: "",
      isConfirmationModalOpen: false,
      selectedConfirmation: "",
      loadingEditModal: false,
      newComment: "",
      comments: "",
    });
  }
  handleConfirmationClick = () => {
    this.setState({
      isConfirmationModalOpen: true,
      selectedConfirmation: this.state.Confirmation,
    });
  };

  handleConfirmationChange = (e) => {
    this.setState({ selectedConfirmation: e.target.value });
  };

  handleConfirmationSubmit = async () => {
    try {
      await axios.post(`${apiUrl}api/patients/updateConfirmation`, {
        userid: this.state.userid,
        Confirmation: this.state.selectedConfirmation,
      });
      toast.success(
        `Confirmation Updated to: ${this.state.selectedConfirmation}`
      );
      this.setState({
        Confirmation: this.state.selectedConfirmation,
        isConfirmationModalOpen: false,
      });
      this.fetchData();
    } catch (error) {
      console.error("Error updating confirmation:", error);
    }
  };

  handleConfirmationCancel = () => {
    this.setState({ isConfirmationModalOpen: false });
  };

  // TAT notification methods
  checkTatNotifications = () => {
    const {
      patients,
      tatNotifications,
      isShowingNotification,
      notificationQueue,
    } = this.state;
    const currentTime = new Date();
    const newNotifications = [];

    patients.forEach((patient) => {
      const patientId = patient._id;
      const Priority = (patient.deviceInfo && patient.deviceInfo.Priority) || 4;

      // Calculate time limit based on priority
      let timeLimit;
      switch (Priority) {
        case 1:
          timeLimit = 1;
          break;
        case 2:
          timeLimit = 2;
          break;
        case 3:
          timeLimit = 3;
          break;
        case 4:
          timeLimit = 4;
          break;
        case 5:
          timeLimit = 5;
          break;
        default:
          timeLimit = 4;
      }

      // Get the final time for calculation
      let finalTime;
      if (patient.ConfirmupdatedDate) {
        let confirmButtonTime = patient.ConfirmupdatedDate.split("T");
        let confirmDate = confirmButtonTime[0];
        let confirmTime = confirmButtonTime[1]
          ? confirmButtonTime[1].split("Z")[0]
          : "";
        if (confirmTime) {
          let time = confirmTime.split(".")[0];
          finalTime = confirmDate + " " + time;
        }
      } else if (patient.updatedDate) {
        let updatedDateTime = patient.updatedDate.split(" ");
        let updatedDate = updatedDateTime[0];
        let updatedTime = updatedDateTime[1];
        finalTime = updatedDate + " " + updatedTime;
      }

      if (finalTime) {
        const finalDate = new Date(finalTime);

        // Skip if date is invalid
        if (isNaN(finalDate.getTime())) {
          return;
        }

        const timeDifference = currentTime - finalDate;
        const hoursDifference = timeDifference / (1000 * 60 * 60);

        // Skip if time difference is negative (future date) or invalid
        if (hoursDifference < 0 || isNaN(hoursDifference)) {
          return;
        }

        let exp_device =
          patient.exp_device_use_days === 24
            ? 1
            : patient.exp_device_use_days === 48
            ? 2
            : patient.exp_device_use_days === 72
            ? 3
            : patient.exp_device_use_days;

        const timePercentage = Math.min(
          (hoursDifference / (timeLimit * exp_device)) * 100,
          100
        );

        // Calculate remaining time
        const completionRate = timePercentage / hoursDifference;
        const totalCompletionTime = 100 / completionRate;
        const remainingTimeInHours = totalCompletionTime - hoursDifference;
        const remainingTimeInMinutes = remainingTimeInHours * 60;
        const hours = Math.floor(remainingTimeInMinutes / 60);
        const minutes = Math.round(remainingTimeInMinutes % 60);

        // Handle edge case where completion rate is 0 or negative
        if (
          completionRate <= 0 ||
          isNaN(completionRate) ||
          !isFinite(completionRate)
        ) {
          return; // Skip this patient if calculation is invalid
        }

        // Check if we should show notification
        const notificationKey = `${patientId}_${
          timePercentage >= 100 ? "completed" : "warning"
        }`;

        if (!tatNotifications.has(notificationKey)) {
          if (timePercentage >= 100) {
            // TAT completed - add to notification queue
            newNotifications.push({
              type: "error",
              message: `⏰ TAT Time's Up! Patient ${patient.name} (${patient.device_id}) - Priority ${Priority} has exceeded the time limit.`,
              patientId: patientId,
              notificationKey: notificationKey,
            });
            // console.log(
            //   "TAT Time's Up! Patient",
            //   patient.name,
            //   "(" +
            //     patient.device_id +
            //     ")" +
            //     " - Priority " +
            //     Priority +
            //     " has exceeded the time limit."
            // );
          } else if (timePercentage >= 90) {
            // TAT approaching completion - add to notification queue
            newNotifications.push({
              type: "warning",
              message: `⚠️ TAT Alert! Patient ${patient.name} (${
                patient.device_id
              }) - Priority ${Priority} is at ${timePercentage.toFixed(
                1
              )}% completion. Remaining time: ${hours}h ${minutes}m`,
              patientId: patientId,
              notificationKey: notificationKey,
            });
          }
        }
      }
    });

    // Add new notifications to queue and process them
    if (newNotifications.length > 0) {
      const updatedQueue = [...notificationQueue, ...newNotifications];
      this.setState(
        {
          notificationQueue: updatedQueue,
          tatNotifications: new Set([
            ...tatNotifications,
            ...newNotifications.map((n) => n.notificationKey),
          ]),
          lastTatCheck: currentTime,
        },
        () => {
          this.processNotificationQueue();
        }
      );
    } else {
      this.setState({
        tatNotifications: new Set(tatNotifications),
        lastTatCheck: currentTime,
      });
    }
  };

  // Process notification queue - shows one notification at a time
  processNotificationQueue = () => {
    const { notificationQueue, isShowingNotification } = this.state;

    if (isShowingNotification || notificationQueue.length === 0) {
      return;
    }

    const nextNotification = notificationQueue[0];
    const remainingQueue = notificationQueue.slice(1);

    this.setState({
      isShowingNotification: true,
      notificationQueue: remainingQueue,
    });

    // Show the notification
    if (nextNotification.type === "error") {
      toast.error(nextNotification.message, {
        duration: 5000,
        position: "top-center",
      });
      // console.log("Showing toast:", nextNotification.message);
    } else {
      toast(nextNotification.message, {
        duration: 5000,
        position: "top-center",
        style: {
          background: "#f39c12",
          color: "#fff",
        },
      });
      // console.log("Showing toast:", nextNotification.message);
    }

    // Mark notification as shown and process next one immediately
    setTimeout(() => {
      this.setState({ isShowingNotification: false }, () => {
        // Process next notification if available
        if (remainingQueue.length > 0) {
          this.processNotificationQueue();
        }
      });
    }, 5000); // Wait for current notification to finish
  };

  // Reset TAT notifications (call this when needed, e.g., daily reset)
  resetTatNotifications = () => {
    this.setState({
      tatNotifications: new Set(),
      lastTatCheck: null,
      isShowingNotification: false,
      notificationQueue: [],
    });
  };

  // Clear specific patient notification (call this when patient status changes)
  clearPatientTatNotification = (patientId) => {
    const { tatNotifications, notificationQueue } = this.state;
    const newNotifications = new Set(tatNotifications);

    // Remove all notifications for this patient from tracking set
    for (let notification of newNotifications) {
      if (notification.startsWith(patientId + "_")) {
        newNotifications.delete(notification);
      }
    }

    // Remove all notifications for this patient from queue
    const filteredQueue = notificationQueue.filter(
      (notification) => notification.patientId !== patientId
    );

    this.setState({
      tatNotifications: newNotifications,
      notificationQueue: filteredQueue,
    });
  };

  render() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const filteredRows = this.filterRows();
    const { errors, doctors, selectedDoctor, dob } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    /* const { errors,doctors } = this.state;*/

    // Map filtered doctors to options
    // const doctorsList =
    //   filteredDoctors.length > 0
    //     ? filteredDoctors.map((item, i) => (
    //         <option
    //           key={i}
    //           value={item._id}
    //           selected={doctor_name === item.name}
    //         >
    //           {item.name}
    //         </option>
    //       ))
    //     : null;
    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <TopNav profileLink={this.state.profileLink} />
        <Toaster position="top-center" reverseOrder={false} />

        <AddModalReport
          userid={this.state.generatereportuserid}
          onSelectModalReport={this.resetModalReport.bind(this)}
          isOpen={this.state.isModalReportOpen}
          treemenu={this.state.treemenu}
        />
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
        />
        <SideBar menus={this.state.menus} />

        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "6px", background: "#041415", minHeight: "100vh" }}>
          <div className="container-fluid" style={{ padding: "8px 4px" }}>
            <div id="myModalDHome" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      General Settings
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmit}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_minhr,
                              })}
                              name="nor_minhr"
                              required=""
                              id="nor_minhr"
                              onChange={this.onChange}
                              value={this.state.nor_minhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_maxhr,
                              })}
                              name="nor_maxhr"
                              required=""
                              id="nor_maxhr"
                              onChange={this.onChange}
                              value={this.state.nor_maxhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Formula
                            </label>
                            <select
                              name="qtcformula"
                              className={classnames("form-control", {
                                errors: errors.qtcformula,
                              })}
                              value={this.state.qtcformula}
                              onChange={this.onChange}
                            >
                              <option value="Bazett">Bazett </option>
                              <option value="Fridericia">Fridericia</option>
                              <option value="Framingham">Framingham</option>
                              <option value="Hodges">Hodges</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvalue_min,
                              })}
                              name="qtcvalue_min"
                              required=""
                              id="qtcvalue_min"
                              onChange={this.onChange}
                              value={this.state.qtcvalue_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvaluemax,
                              })}
                              name="qtcvaluemax"
                              required=""
                              id="qtcvaluemax"
                              onChange={this.onChange}
                              value={this.state.qtcvaluemax}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Min(ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_min,
                              })}
                              name="qrswidth_min"
                              required=""
                              id="qrswidth_min"
                              onChange={this.onChange}
                              value={this.state.qrswidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Max (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_max,
                              })}
                              name="qrswidth_max"
                              required=""
                              id="qrswidth_max"
                              onChange={this.onChange}
                              value={this.state.qrswidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_min,
                              })}
                              name="qrsamp_min"
                              required=""
                              id="qrsamp_min"
                              onChange={this.onChange}
                              value={this.state.qrsamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_max,
                              })}
                              name="qrsamp_max"
                              required=""
                              id="qrsamp_max"
                              onChange={this.onChange}
                              value={this.state.qrsamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Elevation (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stelevation,
                              })}
                              name="stelevation"
                              required=""
                              id="stelevation"
                              onChange={this.onChange}
                              value={this.state.stelevation}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Min (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_min,
                              })}
                              name="pwidth_min"
                              required=""
                              id="pwidth_min"
                              onChange={this.onChange}
                              value={this.state.pwidth_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_max,
                              })}
                              name="pwidth_max"
                              required=""
                              id="pwidth_max"
                              onChange={this.onChange}
                              value={this.state.pwidth_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_min,
                              })}
                              name="pamp_min"
                              required=""
                              id="pamp_min"
                              onChange={this.onChange}
                              value={this.state.pamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_max,
                              })}
                              name="pamp_max"
                              required=""
                              id="pamp_max"
                              onChange={this.onChange}
                              value={this.state.pamp_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Min (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_min,
                              })}
                              name="twidth_min"
                              required=""
                              id="twidth_min"
                              onChange={this.onChange}
                              value={this.state.twidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_max,
                              })}
                              name="twidth_max"
                              required=""
                              id="twidth_max"
                              onChange={this.onChange}
                              value={this.state.twidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_min,
                              })}
                              name="tamp_min"
                              required=""
                              id="tamp_min"
                              onChange={this.onChange}
                              value={this.state.tamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_max,
                              })}
                              name="tamp_max"
                              required=""
                              id="tamp_max"
                              onChange={this.onChange}
                              value={this.state.tamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Min{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_min,
                              })}
                              name="printerval_min"
                              required=""
                              id="printerval_min"
                              onChange={this.onChange}
                              value={this.state.printerval_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Max{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_max,
                              })}
                              name="printerval_max"
                              required=""
                              id="printerval_max"
                              onChange={this.onChange}
                              value={this.state.printerval_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_lower,
                              })}
                              name="tachyhr_lower"
                              required=""
                              id="tachyhr_lower"
                              onChange={this.onChange}
                              value={this.state.tachyhr_lower}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_upper,
                              })}
                              name="tachyhr_upper"
                              required=""
                              id="tachyhr_upper"
                              onChange={this.onChange}
                              value={this.state.tachyhr_upper}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_lower,
                              })}
                              name="bradyhr_lower"
                              required=""
                              id="bradyhr_lower"
                              onChange={this.onChange}
                              value={this.state.bradyhr_lower}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_upper,
                              })}
                              name="bradyhr_upper"
                              required=""
                              id="bradyhr_upper"
                              onChange={this.onChange}
                              value={this.state.bradyhr_upper}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Depression (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stdepression,
                              })}
                              name="stdepression"
                              required=""
                              id="stdepression"
                              onChange={this.onChange}
                              value={this.state.stdepression}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pause Length (s){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pauselength,
                              })}
                              name="pauselength"
                              required=""
                              id="pauselength"
                              onChange={this.onChange}
                              value={this.state.pauselength}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Graphs To Be Generated(no:){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.graph_gen,
                              })}
                              name="graph_gen"
                              required=""
                              id="graph_gen"
                              onChange={this.onChange}
                              value={this.state.graph_gen}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-success"
                        style={{ color: "Black" }}
                        disabled={this.state.loadingEditModal} // Disable while loading
                      >
                        Submit
                      </button>
                      {
                        <button
                          id="closePopup"
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                        >
                          Close
                        </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* ── Comments Modal ── */}
            <div id="commentinfomodal" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 860, margin: "20px auto", width: "94%" }}>
                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>
                  {/* Header */}
                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>💬 Comments{(this.state.comments || "").trim() ? ` (${(this.state.comments || "").trim().split("\n").filter(l => l.trim()).length})` : ""}</div>
                      {this.state.patient_name && (
                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>{this.state.patient_name}</div>
                      )}
                    </div>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                  </div>
                  {/* Comment History */}
                  {(() => {
                    const raw = (this.state.comments || "").trim();
                    const lines = (raw ? raw.split("\n").filter((l) => l.trim()) : []).reverse(); // newest first
                    return (
                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: "calc(100vh - 360px)", minHeight: 120, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                        {lines.length === 0 ? (
                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                        ) : (
                          lines.map((line, idx) => {
                            const byMatch = line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/) || line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i);
                            const text = byMatch ? byMatch[1].trim() : line;
                            const author = byMatch ? byMatch[2].trim() : "";
                            const time = byMatch ? byMatch[3] || "" : "";
                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase() : "?";
                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                            return (
                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>{initials}</div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, whiteSpace: "pre-line", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>{text.replace(/^\[[A-Za-z]+\][^|]*\|\s*/, "")}</div>
                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || (/^\[[A-Za-z]+\][^|]*\|/.test(text) ? "System · " + text.split("|")[0].replace(/[\[\]]/g, "").trim() : "Unknown")}</span>
                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })()}
                  {/* New Comment Input */}
                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                    <textarea
                      value={this.state.newComment || ""}
                      onChange={(e) => this.setState({ newComment: e.target.value })}
                      placeholder="Type your observation, finding or note here…"
                      maxLength={300} rows={3}
                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6 }}
                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                    />
                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                      {(this.state.newComment || "").length}/300
                    </div>
                  </div>
                  {/* Footer */}
                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>Cancel</button>
                    <button id={this.state.userid} type="button" onClick={this.submitComment}
                      disabled={!(this.state.newComment || "").trim()}
                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed" }}>
                      ✓ Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="showblockreport"
              className="modal fade"
              role="dialog"
              aria-labelledby="showblockreportLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title text-center">Block Report</h4>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label style={{ color: "black" }}>Block Report</label>
                      <select
                        className="form-control"
                        value={this.state.blockReportOption}
                        onChange={(e) =>
                          this.setState({ blockReportOption: e.target.value })
                        }
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="row row-sm-offset">
                      <div className="col-md-6 multi-horizontal">
                        <button
                          id={this.state.userid}
                          data-dismiss="modal"
                          type="submit"
                          className="btn btn-success"
                          style={{ color: "Black" }}
                          onClick={async () => {
                            const data = await axios.post(
                              `${apiUrl}api/common/updateblockPatient`,
                              {
                                userid: this.state.userid,
                                block: this.state.blockReportOption,
                              }
                            );
                            console.log(data);
                            if (this.state.blockReportOption === "Yes") {
                              toast.success("Patient Report Blocked");
                            } else if (this.state.blockReportOption === "No") {
                              toast.success("Patient Report Unblocked");
                            }

                            this.setState({
                              blockReportOption: "",
                              showBlockReportModal: false,
                            });
                          }}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-6 multi-horizontal text-left">
                        <button
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {(this.state.verifiertype === "8" || this.state.verifiertype === "1" || this.state.verifiertype === "10") && (
              <div
                id="progressinfomodal"
                className="modal fade"
                role="dialog"
                aria-labelledby="commentModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div
                    className="modal-content"
                    style={{
                      background: "#14171f",
                      border: "1px solid #242833",
                      color: "#e6e6e6",
                      borderRadius: 12,
                    }}
                  >
                    <div
                      className="modal-header"
                      style={{
                        background: "#0f1117",
                        borderBottom: "1px solid #242833",
                        padding: "12px 16px",
                        borderRadius: "12px 12px 0 0",
                      }}
                    >
                      <button
                        onClick={this.resetInfoModal.bind(this)}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{ color: "#8a93a0", opacity: 0.9, fontSize: 22, marginTop: 0 }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4
                        className="modal-title text-center"
                        id="commentModalLabel"
                        style={{ color: "#fff", fontSize: 15, fontWeight: 600 }}
                      >
                        Verifier Progress
                      </h4>
                    </div>

                    <div
                      className="modal-body"
                      style={{ padding: "14px 16px", maxHeight: "60vh", overflowY: "auto" }}
                    >
                      {(() => {
                        // Show only verifiers who actually verified at least one
                        // file for this patient. selectedVerifiersEfficency is
                        // populated by getverifiedprogress; entries exist only
                        // when a verifier has files for the patient.
                        const eff = this.state.selectedVerifiersEfficency || [];
                        const sv = this.state.selectedVerifiers || [];
                        const active = eff
                          .map((e) => {
                            const v = sv.find((x) => x.value === e.label);
                            return v ? { ...e, name: v.label } : null;
                          })
                          .filter(Boolean);

                        // While the API chain is running and we don't yet
                        // have any verifier results to render, show a spinner
                        // instead of the "no activity" placeholder.
                        if (
                          this.state.loadingVerifierProgress &&
                          active.length === 0
                        ) {
                          return (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "40px 16px",
                                color: "#8a93a0",
                                fontSize: 13,
                                gap: 14,
                              }}
                            >
                              <div
                                style={{
                                  width: 38,
                                  height: 38,
                                  border: "3px solid #242833",
                                  borderTop: "3px solid #3F8EFC",
                                  borderRadius: "50%",
                                  animation:
                                    "vp-spin 0.9s linear infinite",
                                }}
                              />
                              <div>Loading verifier progress…</div>
                              {/* Indeterminate progress bar */}
                              <div
                                style={{
                                  width: "70%",
                                  maxWidth: 260,
                                  height: 4,
                                  background: "#1f232c",
                                  borderRadius: 999,
                                  overflow: "hidden",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    height: "100%",
                                    width: "40%",
                                    background:
                                      "linear-gradient(90deg, #3F8EFC, #2ECD99)",
                                    borderRadius: 999,
                                    animation:
                                      "vp-slide 1.4s ease-in-out infinite",
                                  }}
                                />
                              </div>
                              <style>{`
                                @keyframes vp-spin{to{transform:rotate(360deg)}}
                                @keyframes vp-slide{
                                  0%{left:-40%}
                                  100%{left:100%}
                                }
                              `}</style>
                            </div>
                          );
                        }

                        if (active.length === 0) {
                          return (
                            <div
                              style={{
                                color: "#8a93a0",
                                textAlign: "center",
                                padding: "32px 16px",
                                fontSize: 13,
                              }}
                            >
                              No verification activity yet for this patient.
                            </div>
                          );
                        }

                        // Sort: most files done first
                        active.sort(
                          (a, b) =>
                            (Number(b.totalEfficientCount) || 0) -
                            (Number(a.totalEfficientCount) || 0)
                        );

                        const fmtTime = (iso) => {
                          if (!iso || isNaN(Date.parse(iso))) return "—";
                          const d = new Date(iso);
                          return `${d.toLocaleDateString("en-IN")} ${d.toLocaleTimeString(
                            "en-IN",
                            { hour: "2-digit", minute: "2-digit", hour12: true }
                          )}`;
                        };

                        const tierColor = (e) => {
                          if (e >= 81) return "#22c55e"; // green
                          if (e >= 71) return "#84cc16"; // lime
                          if (e >= 41) return "#eab308"; // amber
                          return "#ef4444"; // red
                        };

                        return active.map((v, idx) => {
                          const effPct = Number(v.value) || 0;
                          const color = tierColor(effPct);
                          const avgPerFile = Number(v.averageTimePerECG) || 0;
                          return (
                            <div
                              key={idx}
                              style={{
                                background: "#181c25",
                                border: "1px solid #242833",
                                borderRadius: 10,
                                padding: "12px 14px",
                                marginBottom: 10,
                              }}
                            >
                              {/* Header: name + efficiency pill */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: 8,
                                }}
                              >
                                <div
                                  style={{
                                    color: "#e6e6e6",
                                    fontSize: 14,
                                    fontWeight: 600,
                                  }}
                                >
                                  {v.name}
                                </div>
                                <div
                                  style={{
                                    color,
                                    background: `${color}1f`,
                                    border: `1px solid ${color}55`,
                                    borderRadius: 999,
                                    padding: "2px 10px",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    fontVariantNumeric: "tabular-nums",
                                  }}
                                >
                                  {effPct.toFixed(0)}% efficient
                                </div>
                              </div>

                              {/* Stat strip */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(3, 1fr)",
                                  gap: 10,
                                  marginBottom: 10,
                                }}
                              >
                                <div>
                                  <div style={{ fontSize: 10, color: "#8a93a0", textTransform: "uppercase", letterSpacing: 0.5 }}>
                                    Files done
                                  </div>
                                  <div style={{ color: "#e6e6e6", fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                                    {v.totalEfficientCount || 0}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ fontSize: 10, color: "#8a93a0", textTransform: "uppercase", letterSpacing: 0.5 }}>
                                    Avg / file
                                  </div>
                                  <div style={{ color: "#e6e6e6", fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                                    {avgPerFile > 0 ? `${avgPerFile.toFixed(1)} min` : "—"}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ fontSize: 10, color: "#8a93a0", textTransform: "uppercase", letterSpacing: 0.5 }}>
                                    Time spent
                                  </div>
                                  <div style={{ color: "#e6e6e6", fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                                    {v.totalSpendHours || "—"}
                                  </div>
                                </div>
                              </div>

                              {/* Time range */}
                              <div style={{ fontSize: 11, color: "#6b7380", marginBottom: 8 }}>
                                {fmtTime(v.startTime)} — {fmtTime(v.endTime)}
                              </div>

                              {/* Efficiency bar */}
                              <div
                                style={{
                                  height: 6,
                                  background: "#1f232c",
                                  borderRadius: 999,
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    width: `${Math.min(100, Math.max(0, effPct))}%`,
                                    height: "100%",
                                    background: color,
                                    borderRadius: 999,
                                    transition: "width 0.3s ease",
                                  }}
                                />
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </div>

                  </div>
                </div>
              </div>
            )}

            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      onClick={this.resetInfoModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Edit Patient Information
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div
                      className="modal-body"
                      style={{ position: "relative" }}
                    >
                      {/* Full-modal loading overlay */}
                      {this.state.loadingEditModal && (
                        <div
                          className="modal-loading-overlay"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.7)",
                            zIndex: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="spinner-edit-modal"
                            style={{
                              width: 48,
                              height: 48,
                              border: "6px solid #f3f3f3",
                              borderTop: "6px solid #3498db",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          ></div>
                          <style>{`@keyframes spin { 
                        0% { transform: rotate(0deg); } 
                        100% { transform: rotate(360deg); } 
                      }`}</style>
                        </div>
                      )}

                      {/* Row 1: Name, Email, Phone */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="patient_name"
                              onChange={this.onChange}
                              value={this.state.patient_name}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Email</label>
                            <input
                              type="text"
                              className="form-control"
                              name="email_id"
                              onChange={this.onChange}
                              value={this.state.email_id}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Phone</label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              onChange={this.onChange}
                              value={this.state.phone}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 2: Doctor Name, Hospital, IP/OP */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Hospital Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="hospital"
                              onChange={this.onChange}
                              value={this.state.hospital}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Doctor Name
                            </label>
                            <Select
                              options={options}
                              value={selectedDoctor}
                              onChange={this.handleDoctorChange}
                              placeholder="Search Doctor"
                              classNamePrefix="react-select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  borderColor: errors.doctor_id
                                    ? "red"
                                    : base.borderColor,
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>IP/OP</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onIpOpChange}
                              value={this.state.ipop}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 3: DOB + File Type + Confirmation */}
                      <div className="row">
                        {/* DOB */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>DOB</label>
                            <div className="input-group">
                              <Datetime
                                value={dob}
                                onChange={this.handleDateChange}
                                inputProps={{
                                  className: `form-control ${
                                    errors.dob ? "is-invalid" : ""
                                  }`,
                                  placeholder: "Select Date",
                                }}
                                dateFormat="MM/DD/YYYY"
                                timeFormat={false}
                              />
                              <span className="input-group-addon">
                                <span className="fa fa-calendar"></span>
                              </span>
                            </div>
                            {errors.dob && (
                              <div className="invalid-feedback">
                                {errors.dob}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* File Type */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>File Type</label>
                            <select
                              className="form-control"
                              value={this.state.filetype}
                              onChange={this.handleTypeChange}
                            >
                              <option value="easy">Easy</option>
                              <option value="moderate">Moderate</option>
                              <option value="hard">Hard</option>
                            </select>
                          </div>
                        </div>

                        {/* Confirmation */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Confirmation
                            </label>
                            {/* Yes / No / Hold — same buttons and save as Patient List's Edit Patient */}
                            <div className="btn-group" style={{ width: "100%", display: "flex" }}>
                              {[
                                { v: "Yes", color: "#27ae60" },
                                { v: "No", color: "#e74c3c" },
                                { v: "Hold", color: "#f39c12" },
                                ...(livePatientsEnabled ? [{ v: "Live", color: "#8e44ad" }] : []),
                              ].map((item, i, arr) => (
                                <button
                                  key={item.v}
                                  type="button"
                                  onClick={() => {
                                    this.setState({ Confirmation: item.v, selectedConfirmation: item.v });
                                    axios
                                      .post(`${apiUrl}api/patients/updateConfirmation`, {
                                        userid: this.state.userid,
                                        Confirmation: item.v,
                                        ConfirmationSource: "staff",
                                        ConfirmedBy: localStorage.getItem("verifiername") || "Unknown staff",
                                        ConfirmedById: localStorage.getItem("verifierid") || null,
                                      })
                                      .then(() => {
                                        toast.success(`Confirmation Updated to: ${item.v}`);
                                        this.fetchData();
                                      })
                                      .catch((err) => console.error("Confirmation update error:", err));
                                  }}
                                  style={{
                                    flex: 1,
                                    height: 46,
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    border: "1px solid #ccc",
                                    background: this.state.Confirmation === item.v ? item.color : "#fff",
                                    color: this.state.Confirmation === item.v ? "#fff" : "#555",
                                    cursor: "pointer",
                                    borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length - 1 ? "0 4px 4px 0" : "0",
                                  }}
                                >
                                  {item.v}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Row 4: Priority, Report Status, Atrial Fib */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Priority</label>
                            <select
                              className="form-control"
                              value={this.state.priority}
                              onChange={this.onPriorityChange}
                            >
                              <option value="4">NA</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Report Status
                            </label>
                            <select
                              className="form-control"
                              value={this.state.reportstatus}
                              onChange={this.onReportStatuschange}
                            >
                              <option value="0">Not Analayzed</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Atrial Fibrillation
                            </label>
                            <select
                              className="form-control"
                              value={this.state.af}
                              onChange={this.onChange}
                            >
                              <option value="">Choose</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 5: Indication, Duration, Gender */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Indication</label>
                            <input
                              type="text"
                              className="form-control"
                              name="indication"
                              onChange={this.onChange}
                              value={this.state.indication}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Monitoring Duration
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onDurationChange}
                              value={this.state.duration}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Gender</label>
                            <select
                              className="form-control"
                              onChange={this.onGenderChange}
                              value={this.state.gender}
                            >
                              <option value="M">M</option>
                              <option value="F">F</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 6: Issue Noticed, Cardiac Surgery, Pacemaker */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Issue Noticed
                            </label>
                            <select
                              className="form-control"
                              value={this.state.issueReport}
                              onChange={(e) =>
                                this.setState({ issueReport: e.target.value })
                              }
                            >
                              <option value="NA">Not Selected</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low data</option>
                              <option value="customer_reject">
                                Customer Reject
                              </option>
                              <option value="battery_issue">
                                Battery Issue
                              </option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Cardiac Surgery/Interventions
                            </label>
                            <select
                              className="form-control"
                              value={this.state.cardiac_surgery}
                              onChange={this.onChange}
                            >
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Pacemaker</label>
                            <select
                              className="form-control"
                              value={this.state.pacemaker}
                              onChange={(e) => {
                                this.setState({
                                  pacemaker: e.target.value === "true",
                                });
                              }}
                            >
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* Row 7: Support Person + Support Level + Supported Matter */}
                      <div className="row">
                        {/* Support Person Dropdown */}
                        {/* Support Person Dropdown */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Person
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportPerson}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportPerson: e.target.value })
                              }
                            >
                              <option value="">Select Person</option>
                              {this.state.supportPersons &&
                              this.state.supportPersons.length > 0 ? (
                                this.state.supportPersons.map((person) => (
                                  <option key={person._id} value={person._id}>
                                    {person.name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading...</option>
                              )}
                            </select>
                          </div>
                        </div>

                        {/* Support Level Dropdown */}
                        <div className="col-md-2">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Level
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportLevel}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportLevel: e.target.value })
                              }
                            >
                              <option value="">Select Level</option>
                              <option value="L0">L0</option>
                              <option value="L1">L1</option>
                              <option value="L2">L2</option>
                              <option value="L3">L3</option>
                            </select>
                          </div>
                        </div>

                        {/* Supported Matter Textarea */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Supported Matter
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.supportedMatter}
                              onChange={(e) =>
                                // console.log(e.target.value) ||
                                this.setState({
                                  supportedMatter: e.target.value,
                                })
                              }
                              placeholder="Enter details..."
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Prioritize Data
                            </label>
                            <select
                              className="form-control"
                              value={this.state.prioritizeData}
                              onChange={(e) =>
                                this.setState({
                                  prioritizeData: e.target.value,
                                })
                              }
                            >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Assign Verifier
                            </label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              styles={{
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected
                                    ? "blue"
                                    : state.isFocused
                                    ? "#e5e5e5"
                                    : null,
                                  color: state.isSelected ? "white" : "black",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  backgroundColor: "blue",
                                }),
                                multiValueLabel: (provided) => ({
                                  ...provided,
                                  color: "white",
                                }),
                              }}
                            />

                            {this.state.selectedVerifiers.length > 0 && (
                              <div style={{ marginTop: "10px" }}>
                                <strong>Selected Verifiers:</strong>{" "}
                                {this.state.selectedVerifiers
                                  .map((verifier) => verifier.label)
                                  .join(", ")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Row 9: Clinical Condition */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Clinical Condition
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.clinicalCondition}
                              onChange={(e) =>
                                this.setState({
                                  clinicalCondition: e.target.value,
                                })
                              }
                              placeholder="Enter clinical condition..."
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer with separate divs for Submit and Close */}
                    <div className="modal-footer d-flex justify-content-center gap-3">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={this.state.loadingEditModal}
                      >
                        Submit
                      </button>

                      <button
                        type="button"
                        className="btn btn-default closePopup"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {this.state.isConfirmationModalOpen && (
              <div
                id="ConfirmInfoModal"
                className="modal fade in"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        onClick={this.handleConfirmationCancel}
                      >
                        &times;
                      </button>
                      <h4 className="modal-title text-center">
                        Confirmation Status
                      </h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label
                          className="form-control-label mbr-fonts-style display-7"
                          style={{ color: "Black" }}
                        >
                          Select Status
                        </label>
                        <select
                          className="form-control"
                          value={this.state.selectedConfirmation}
                          onChange={this.handleConfirmationChange}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                          <option value="Hold">Hold</option>
                        {livePatientsEnabled && <option value="Live">Live</option>}
                        </select>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-success"
                        data-dismiss="modal"
                        onClick={this.handleConfirmationSubmit}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        data-dismiss="modal"
                        onClick={this.handleConfirmationCancel}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12" style={{ padding: "0 8px" }}>
                <div style={{ background: "#072224", borderRadius: "6px", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.25)" }}>

                  {/* ── Compact toolbar ── */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "7px 12px", background: "#051a1c", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
                    <span style={{ color: "#c5d8e8", fontWeight: 700, fontSize: "13px", letterSpacing: "0.4px" }}>
                      ✅ Verified Patients
                      {this.state.rows && this.state.rows.length > 0 && (
                        <span style={{ marginLeft: 8, fontSize: "11px", fontWeight: 400, color: "#6a93b0", background: "rgba(255,255,255,0.07)", borderRadius: 10, padding: "1px 8px" }}>
                          {this.filterRows().length} shown
                        </span>
                      )}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <select
                        value={this.state.statusFilter}
                        onChange={(e) => this.setState({ statusFilter: e.target.value })}
                        style={{ height: 28, fontSize: "12px", padding: "2px 8px", borderRadius: 4, border: "1px solid #0e3538", background: "#041415", color: "#c5d8e8", outline: "none", cursor: "pointer" }}
                      >
                        <option value="All">All</option>
                        <option value="Not Started">Not Started</option>
                        <option value="Analyze Started">Analyze Started</option>
                        <option value="Analyze Completed">Analyze Completed</option>
                      </select>
                      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                        <span style={{ position: "absolute", left: 8, color: "#6a93b0", fontSize: "13px", pointerEvents: "none" }}>🔍</span>
                        <input
                          type="text"
                          placeholder="Search patient, doctor…"
                          style={{ height: 28, paddingLeft: 26, paddingRight: 8, fontSize: "12px", borderRadius: 4, border: "1px solid #0e3538", background: "#041415", color: "#c5d8e8", outline: "none", width: 200 }}
                          value={this.state.searchQuery}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ padding: "0" }}>
                    <table className="table table-striped" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                      <colgroup>
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "13%" }} />
                        <col style={{ width: "18%" }} />
                        <col style={{ width: "39%" }} />
                      </colgroup>
                      <thead>
                        <tr style={{ background: "#031213" }}>
                          <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>SL</th>
                          <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>PATIENT</th>
                          <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>CREATED DATE</th>
                          <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>CUSTOMER NAME</th>
                          <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>DOCTOR NAME</th>
                          <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>MONITORING</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          // Grouped by priority band (High → Moderate →
                          // Simple → Normal). Inside every band rows are
                          // ordered oldest upload first, so patients that
                          // share a priority level queue by upload time.
                          const allRows = this.filterRows();
                          const priorityGroups = [
                            { key: 1, label: "HIGH PRIORITY", color: "#c0392b", bg: "rgba(192,57,43,0.10)",  border: "#c0392b", dot: "🔴" },
                            { key: 2, label: "MODERATE",      color: "#d68910", bg: "rgba(214,137,16,0.10)", border: "#d68910", dot: "🟡" },
                            { key: 3, label: "SIMPLE",        color: "#2980b9", bg: "rgba(41,128,185,0.10)", border: "#2980b9", dot: "🔵" },
                            { key: 4, label: "UNPRIORITISED", color: "#8095a3", bg: "rgba(128,149,163,0.08)", border: "#5b7688", dot: "⚪" },
                          ];
                          let globalIndex = 0;
                          return priorityGroups.map(group => {
                            const groupRows = allRows
                              .filter(r => (r.priorityNum || 4) === group.key)
                              .sort((a, b) => (a.uploadMs || 0) - (b.uploadMs || 0));
                            if (groupRows.length === 0) return null;
                            return (
                              <React.Fragment key={group.key}>
                                <tr>
                                  <td colSpan={6} style={{ padding: "5px 10px", background: group.bg, borderLeft: `4px solid ${group.border}`, borderTop: "1px solid rgba(255,255,255,0.06)" }}>
                                    <span style={{ color: group.color, fontWeight: 700, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.8px" }}>
                                      {group.dot} {group.label}
                                    </span>
                                    <span style={{ fontSize: "11px", color: "#888", marginLeft: 8 }}>
                                      {groupRows.length} patient{groupRows.length !== 1 ? "s" : ""}
                                    </span>
                                  </td>
                                </tr>
                                {groupRows.map((row, rowIndex) => {
                                  const displayIndex = ++globalIndex;
                                  return (
                                    <tr key={row._id || rowIndex}>
                                      <td style={{ textAlign: "center", verticalAlign: "middle" }}>{displayIndex}</td>
                                      <td onClick={this.handleRowClick} style={{ cursor: "pointer", verticalAlign: "middle", textAlign: "center" }}>
                                        <div style={{ fontWeight: 700, fontSize: "13px", lineHeight: 1.3 }}>{row.patientId}</div>
                                        <div style={{ fontSize: "12px", opacity: 0.75, marginTop: "2px" }}>{row.name}</div>
                                        {row.confirmation === "Live" && <LiveTag />}
                                      </td>
                                      <td style={{ verticalAlign: "middle", textAlign: "center" }}>{row.added_date}</td>
                                      <td style={{ verticalAlign: "middle", textAlign: "center" }}>{row.distributor}</td>
                                      <td style={{ verticalAlign: "middle", textAlign: "center" }}>{row.doctor_name}</td>
                                      <td style={{ verticalAlign: "top" }}>{row.monitoring_duration}</td>
                                    </tr>
                                  );
                                })}
                              </React.Fragment>
                            );
                          });
                        })()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <EcgStripsModal
          userid={this.state.stripsUserid}
          onClose={() => this.setState({ stripsUserid: null })}
        />
      </div>
    );
  }
}

export default VerificationCompletedList;
